import { render, staticRenderFns } from "./TheBuildingAddForm.vue?vue&type=template&id=1328266d&"
import script from "./TheBuildingAddForm.vue?vue&type=script&lang=js&"
export * from "./TheBuildingAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports